import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, Typography } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import CallEndIcon from "@mui/icons-material/CallEnd";
import {
  acceptIncomingVoiceCall,
  rejectIncomingVoiceCall,
} from "../../realtimeCommunication/socketConnection";

const VoiceCallDialog = () => {
  const [incomingCall, setIncomingCall] = useState(null);

  useEffect(() => {
    const handleIncomingCall = (event) => {
      setIncomingCall(event.detail);
    };
    const handleCallEnded = () => {
      setIncomingCall(null);
    };

    window.addEventListener("voice-call-incoming", handleIncomingCall);
    window.addEventListener("voice-call-ended", handleCallEnded);

    return () => {
      window.removeEventListener("voice-call-incoming", handleIncomingCall);
      window.removeEventListener("voice-call-ended", handleCallEnded);
    };
  }, []);

  const handleAccept = async () => {
    await acceptIncomingVoiceCall();
    setIncomingCall(null);
  };

  const handleReject = () => {
    rejectIncomingVoiceCall();
    setIncomingCall(null);
  };

  return (
    <Dialog
      open={Boolean(incomingCall)}
      onClose={handleReject}
      PaperProps={{
        sx: {
          bgcolor: "#282a30",
          color: "#f2f3f5",
          borderRadius: "8px",
          width: "360px",
          p: "24px",
          boxShadow: "0 16px 40px rgba(0,0,0,0.45)",
        },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "18px" }}>
        <Box
          sx={{
            width: "64px",
            height: "64px",
            borderRadius: "50%",
            bgcolor: "#f97316",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CallIcon sx={{ fontSize: 34 }} />
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Входящий голосовой вызов
          </Typography>
          <Typography sx={{ color: "#b5bac1", mt: "4px" }}>
            {incomingCall?.callerName} звонит вам
          </Typography>
        </Box>
        <Box sx={{ display: "flex", width: "100%", gap: "12px" }}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<CallIcon />}
            onClick={handleAccept}
            sx={{
              bgcolor: "#f97316",
              textTransform: "none",
              "&:hover": { bgcolor: "#ea580c" },
            }}
          >
            Принять
          </Button>
          <Button
            fullWidth
            variant="contained"
            startIcon={<CallEndIcon />}
            onClick={handleReject}
            sx={{
              bgcolor: "#da373c",
              textTransform: "none",
              "&:hover": { bgcolor: "#a12828" },
            }}
          >
            Отклонить
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default VoiceCallDialog;
